import { ADVANCED_READONLY_USER_ROLE } from '@/constants/userRoles';
import { createVNode, render, nextTick } from 'vue';
import {
  iTooltip,
  iTooltipAlignmentMode,
  getTooltipByTarget,
} from '@inscribe/signal';

/**
 * This directive sets the disabled property for buttons that can be accessed by read-only users.
 * @param {*} Vue
 */
export const initReadOnlyCheckDirective = (Vue) => {
  Vue.directive('read-only-check', {
    mounted: function (el, binding, vnode) {
      if (
        typeof binding?.value?.active === 'boolean' &&
        binding?.value?.active === false
      ) {
        return;
      }
      const store = vnode.context.$store;
      const currentUser = store.getters.getCurrentUser;
      if (currentUser.role === ADVANCED_READONLY_USER_ROLE) {
        el.setAttribute(
          'data-read-only-check',
          `read-only-check-${crypto.randomUUID()}`,
        );
        const componentInstance = vnode.context;
        if (typeof componentInstance.setDisabled === 'function') {
          nextTick(() => {
            componentInstance.setDisabled(true);
          });
        } else {
          const internalButton =
            el.nodeName === 'BUTTON' ? el : el.querySelector('button');
          internalButton.setAttribute('disabled', true);
          internalButton.classList.add('disabled');
        }

        addTooltipToElement(el, binding.value);
      }
    },
  });
};

const addTooltipToElement = (el, bindingValue) => {
  nextTick(() => {
    const existingTooltip = getTooltipByTarget(
      bindingValue?.existingTooltipTarget || `#${el.id}`,
    );
    if (existingTooltip) {
      existingTooltip.removeListeners(true);
      existingTooltip.$el.remove();
    }
  });

  const vNode = createVNode(iTooltip, {
    target: `*[data-read-only-check="${el.getAttribute('data-read-only-check')}"`,
    title: bindingValue?.message || 'Not accessible for read-only users',
    alignment: getTooltipAlignment(el, bindingValue),
  });
  const newContainer = document.createElement('div');
  el.parentElement.appendChild(newContainer);
  render(vNode, newContainer);
};

const getTooltipAlignment = (el, bindingValue) => {
  return bindingValue?.alignment || iTooltipAlignmentMode.BOTTOM_MIDDLE;
};
